module.exports = __webpack_public_path__ + "img/qrcode.d0b2c276.png";